import type FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import getFocusedFilterForTable from 'mini-mail-list-store/lib/utils/getFocusedFilterForTable';
import getSelectedTableView from 'mini-mail-list-store/lib/utils/getSelectedTableView';
import { isMiniHostAppFeatureEnabled } from 'mini-hostapp-feature-flags/lib/isMiniHostAppFeatureEnabled';

/**
 * Returns if Ads component can be rendered in the mail list-view.
 * Outlook Lite shows Ads only in the "Others" inbox section.
 * @param nativeAdFormat
 * @param isInMultiSelectMode
 * @returns
 */
export const canShowAdsComponentInListView = (isInMultiSelectMode: boolean = false) => {
    if (isInMultiSelectMode) {
        return false;
    }

    const tableView = getSelectedTableView();
    const focusedViewFilter = getFocusedFilterForTable(tableView);
    if (focusedViewFilter === 0 || focusedViewFilter === -1) {
        return isMiniHostAppFeatureEnabled('adsInFocussedInbox');
    }

    return true;
};
